import { config } from '../../shared/config';

 export class tmOAuthConfig
 {
    public clientId? ='';
    public club? = '';
    public clientSecret? = ''
    public callBackUri? = config.portalUrl +  '/ticketmaster/callback';
    public tokenUri? = 'https://app.ticketmaster.com/acctmgr-oauth/token';
    public loginUri? = 'https://am.ticketmaster.com/padres/sso';
    public authoriseUri? = 'https://app.ticketmaster.com/acctmgr-oauth/authorize';
    public amCookieName? = 'am-token';
    public useCookie? = false;
 }